<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="
        (page) => {
          getParkListData().then((res) => {
            parkListData = res.data;
            onLoad(page);
          });
        }
      "
      @refresh-change="onLoad"
    >
      <template slot="status" slot-scope="scope">
        <el-tag :class="'client-status-class-' + scope.row.status"
          >{{ getstatus(scope.row.status) }}
        </el-tag>
      </template>
      <template slot="feeInfosForm" slot-scope="scope">
        <TableForm
          :viewFlag="tableViewFlag"
          :tableData.sync="form.feeInfos"
          :headerData.sync="headerData"
          :validProp.sync="validPropList"
          @handleData="handleTableFormData"
        />
      </template>
      
      <template slot="menuLeft">
        <!-- <el-button type="primary" icon="el-icon-plus" size="small" @click="addRecord">
          新 增</el-button
        > -->
        <!--<el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.carmonthchargerule_delete"
          @click="handleDelete"
          >删 除
        </el-button>-->
        <el-button
          type="primary"
          size="small"
          icon="el-icon-top"
          v-if="false"
          plain
          @click="monthCarChargeRuleSync"
          >收费规则同步
        </el-button>
      </template>

      <!-- <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-remove-outline"
          @click="disable(scope.row)"
          style="color: #ff0000"
        >停用
        </el-button>
      </template>-->
      <template slot="costPrice" slot-scope="scope">
        {{ tool.money_format_allowvoid(scope.row.costPrice) }}
      </template>
    </avue-crud>
    <el-dialog title='新增' :visible.sync="addFormVisible"
     :append-to-body="true"
      :modal-append-to-body="true"
      :fullscreen="false"
      :close-on-click-modal="false">
      <el-form :model="ruleForm" ref="formRef" :rules="ruleFormRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="所属车场" prop="spaceId">
              <el-select  v-model="ruleForm.spaceId" style="width:100%" placeholder="所属车场">
                <el-option
                  v-for="item in parkListData"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="套餐名称" prop="setmealName">
              <el-input  v-model="form.setmealName" maxlength="20" clearable placeholder="请输入 套餐名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="套餐类型" prop="projectId">
              <el-select  v-model="ruleForm.packageType" style="width:100%" placeholder="套餐类型">
                <el-option
                  v-for="item in packageTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="ruleForm.packageType==1">
            <el-form-item label="车型大小" prop="carType">
              <el-select  v-model="ruleForm.carType" style="width:100%" placeholder="套餐类型">
                <el-option
                  v-for="item in carTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="ruleForm.packageType==2">
            <el-form-item label="子母车位" prop="isDouble">
              <el-select  v-model="ruleForm.isDouble" style="width:100%" placeholder="套餐类型">
                <el-option
                  v-for="item in isDoubleList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="ruleForm.packageType==2">
            <el-form-item label="计费方式" prop="projectId">
              <el-select  v-model="ruleForm.billingMethod" style="width:100%" placeholder="套餐类型">
                <el-option
                  v-for="item in billingMethodList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="ruleForm.billingMethod==2">
            <el-form-item label="收费标准" prop="feeStand">
              <money-input  v-model="form.feeStand" placeholder="请输入 收费标准" templateName="元/平"  template="append" style="width: 100%"  />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="收费标准" prop="feeInfos" v-if="ruleForm.packageType==1||ruleForm.billingMethod==1">
              <el-table
               border
              :data="ruleForm.feeInfos"
              height="300"
              style="width: 100%">
            <el-table-column
            align="center" width="80">
            <template slot="header" slot-scope="scope">
                <el-button
                size="mini" 
                type="primary"
                icon="el-icon-plus" 
                @click="handleAdd(scope.$index, scope.row)" circle></el-button>
            </template>
            <template slot-scope="scope">
              
                <el-button
               
                size="mini"
                type="danger"
                icon="el-icon-delete" 
                @click="tableHandleDelete(scope.$index, scope.row)" circle></el-button>
            </template>
            
            </el-table-column>
            <el-table-column
              prop="feeSort"
              label="收费科目"
             >
              <template slot-scope="scope">
                <el-form
                        :model="scope.row"
                        :ref="'feeInfosRef' + scope.$index"
                        :rules="feeInfosFormRules"
                        label-width="0px"
                      > 
                        <el-row :gutter="24">
                          <el-col :span="24">
                            <el-form-item prop="feeSort">
                           
                          
                              <el-select  v-model="scope.row.feeSort" style="width:100%" placeholder="收费科目">
                                  <el-option
                                    v-for="item in monthcarFeeTypeList"
                                    :key="item.dictKey"
                                    :label="item.dictValue"
                                    :value="item.dictKey"
                                  >
                                  </el-option>
                                </el-select>
                                
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-form>
                
              
              </template>
            </el-table-column>
            <el-table-column
              prop="itemPrice"
              label="收费金额"
             >
              <template slot-scope="scope">
                <el-form
                        :model="scope.row"
                        :ref="'feeInfosRef2' + scope.$index"
                        :rules="feeInfosFormRules"
                        label-width="0px"
                      >
                        <el-row :gutter="24">
                          <el-col :span="24">
                            <el-form-item prop="itemPrice">
                              <money-input  v-model="scope.row.itemPrice" placeholder="请输入 收费金额"  template="append" style="width: 100%"  />
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-form>
               
              
              </template>
            </el-table-column>
            <el-table-column
              prop="remark"
              label="备注信息"
              >
              <template slot-scope="scope">
                <el-input  v-model="scope.row.remark" maxlength="200" clearable placeholder="请输入 备注信息"></el-input>
              
              </template>
             
            </el-table-column>
        </el-table>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收费金额" prop="itemPrice">
              <money-input disabled v-model="form.itemPrice" placeholder="请输入 维修金额"  template="append" style="width: 100%"  />
            </el-form-item>
          </el-col>
          <el-col :span="24" style="text-align: right;">
            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
              提交
            </el-button>
            <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small">
              取消
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  removeItem,
  add,
  getDetail,
  getList,
  remove,
  update,
  disable,
  removeFeeDetail,
  getParkList,
  getFeeSortList,
} from '@/api/v4ward/carv2/carmonthchargerule';
import { mapGetters } from 'vuex';
import TableForm from '@/views/components/table-form';
import { getDictionary } from '@/api/common';
export default {
  components: { TableForm },
  data() {
    var validateFeeInfos = (rule, value, callback) => {
      if(value.length==0){
        callback(new Error('请新增收费标准！'));
          return;
      }
      for (let key in value) {
        let ele = value[key];
        if (this.vdui.isEmpty(ele.feeSort)) {
          callback(new Error('请选择收费科目！'));
          return;
        }
        if (this.vdui.isEmpty(ele.itemPrice)) {
          callback(new Error('请输入收费金额！'));
          return;
        } else if (!this.$validation.money.test(ele.itemPrice)) {
          callback(new Error('金额格式不正确！'));
          return;
        }
      }
      callback();
    };
    var validateFeeInfos1 = (rule, value, callback) => {
      if(value.length==0){
        callback(new Error('请新增收费标准！'));
          return;
      }
      
      callback();
    };
    return {
      ruleFormRules: {
        spaceId: [{ required: true, message: ' ', trigger: 'change' }],
        setmealName: [{ required: true, message: '请输入套餐名称', trigger: 'blur' }],
        packageType: [{ required: true, message: '请选择套餐类型', trigger: 'change' }],
        carType: [{ required: true, message: '请选择套餐类型', trigger: 'change' }],
        isDouble: [{ required: true, message: '请选择子母车位', trigger: 'change' }],
        billingMethod:[{ required: true, message: '请选择子计费方式', trigger: 'change' }],
        feeStand:[{ required: true, message: '请输入收费标准', trigger: 'change' }],
        feeInfos:[{required: true, validator: validateFeeInfos1, trigger: 'change' }]
      },
      feeInfosFormRules:{
        itemPrice:[{ required: true, message: '请输入收费金额', trigger: 'blur' }],
        feeSort:[{ required: true, message: '请选择收费科目', trigger: 'change' }],
       
      },
      packageTypeList:[],//套餐类型
      billingMethodList:[],//计费方式
      carTypeList:[],
      isDoubleList:[
        {
          dictKey:0,
          dictValue:'否'
        },
        {
          dictKey:1,
          dictValue:'是'
        },
      ],
      ruleForm:{
        setmealName:'',
        spaceId:'',
        packageType:'',
        carType:'',
        isDouble:'',
        billingMethod:'',
        feeStand:'',
        feeSort:"",
        feeInfos:[]
      },
      addFormVisible:false,
      tableViewFlag: false,
      validPropList: [],
      headerData: [
        {
          label: '收费科目',
          prop: 'feeSort',
          type: 'select',
          dictCode: 'monthcar_fee_type',
          list: [],
        },
        {
          label: '收费金额',
          prop: 'itemPrice',
          type: 'input',
          maxlength: 9,
        },
        {
          label: '备注信息',
          prop: 'remark',
          type: 'input',
          maxlength: 200,
        },
      ],
      form: {
        feeInfos: [],
      },
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        sarchShow: true,
        searchMenuSpan: 12,
        calcHeight: 30,
        tip: true,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        dialogClickModal: false,
        selectionClearBtn: true,
        stripe: true,
        dialogWidth: '40%',
        column: [
          {
            label: '车场名称',
            type: 'tree',
            prop: 'spaceId',
            labelWidth: 120,
            span: 12,
            search: true,
            // editDisplay: false,
            // viewDisplay: false,
            cell: true,
            props: {
              label: 'title',
              value: 'key',
            },
            rules: [
              {
                required: true,
                message: '请输入车场名称',
              },
            ],
            dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0',
            change: ({ value, column }) => {
              this.generateRemark();
            },
          },
          /*{
            label: '套餐类型',
            type: 'select',
            labelWidth: 120,
            dicUrl: '/api/blade-system/dict/dictionary?code=car_month_package',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            prop: 'packageType',
            search: true,
            rules: [
              {
                required: true,
                message: '请输入套餐类型',
              },
            ],
          },*/
          {
            label: '套餐名称',
            labelWidth: 120,
            prop: 'setmealName',
            maxlength: 32,
            showWordLimit: true,
            span: 12,
            rules: [
              {
                required: true,
                message: '请输入套餐名称',
              },
            ],
          },
          {
            label: '车辆类别',
            type: 'select',
            labelWidth: 120,
            dicUrl: '/api/blade-system/dict/dictionary?code=car_category_v2',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'string',
            prop: 'carCategory',
            // search: true,
            rules: [
              {
                required: true,
                message: '请输入车辆类别',
              },
            ],
            change: ({ value, column }) => {
              this.generateRemark();
            },
          },
          {
            label: '车辆类型',
            type: 'select',
            labelWidth: 120,
            dicUrl: '/api/blade-system/dict/dictionary?code=car_type_v2',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'string',
            prop: 'carType',
            search: true,
            rules: [
              {
                required: true,
                message: '请输入车辆类型',
              },
            ],
            change: ({ value, column }) => {
              this.generateRemark();
            },
          },
          {
            label: '月卡金额(元)',
            prop: 'costPrice',
            labelWidth: 120,
            slot: true,
            align: 'right',
            type: 'number',
            // editDisplay: false,
            // addDisplay: false,
            editDisabled: true,
            addDisabled: true,
            rules: [
              {
                required: true,
                message: '请输入单价',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '减免金额(元)',
            prop: 'cutMoney',
            labelWidth: 120,
            type: 'number',
            value: 0.0,
            hide: true,
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
          },
          {
            label: '收费标准',
            prop: 'feeInfos',
            type: 'table',
            hide: true,
            formslot: true,
            span: 24,
            rules: [
              {
                required: true,
                message: '请添加收费标准',
                trigger: 'blur',
              },
              // { validator: validateFeeInfos, trigger: 'blur' }
            ],
            children: {
              page: false,
              align: 'center',
              headerAlign: 'center',
              rowAdd: (done) => {
                done();
              },
              rowDel: (row, done) => {
                if (this.form.feeInfos.length == 1) {
                  this.$message.warning('请至少保留一条收费标准！');
                } else {
                  this.$confirm('确定要删除收费标准?', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                  })
                    .then(() => {
                      if (row.id) {
                        return removeFeeDetail(row);
                      } else {
                        let res = {};
                        res.success = true;
                        return res;
                      }
                    })
                    .then((res) => {
                      if (res.success) {
                        this.$message.success('收费标准删除成功！');
                        done();
                      } else {
                        this.$message.warning(res.msg);
                      }
                    });
                }
              },
              column: [
                {
                  label: '收费科目',
                  prop: 'feeSort',
                  type: 'select',
                  width: 150,
                  dataType: 'number',
                  dicUrl: 'api/blade-system/dict/dictionary?code=monthcar_fee_type',
                  props: { label: 'dictValue', value: 'dictKey' },
                  rules: [
                    {
                      required: true,
                      message: '请选择收费科目',
                      trigger: 'change',
                    },
                  ],
                },
                {
                  label: '收费金额',
                  prop: 'itemPrice',
                  width: 150,
                  formHeight: 200,
                  clearable: false,
                  precision: 2,
                  minRows: 0.01,
                  blur: () => {
                    let self = this;
                    console.log('self.form.feeInfos=======>', this.form.feeInfos);
                    self.form.costPrice = 0;
                    this.form.feeInfos.forEach((item, index) => {
                      self.form.costPrice = Number(item.itemPrice) + Number(self.form.costPrice);
                    });
                    console.log('self.form.costPrice=======>', self.form.costPrice);
                  },
                  rules: [
                    {
                      required: true,
                      message: '请输入金额',
                      trigger: 'blur',
                    },
                    {
                      required: true,
                      pattern: this.$validation.money,
                      message: '金额格式不对',
                      trigger: 'blur',
                    },
                  ],
                },
                {
                  label: '备注信息',
                  prop: 'remark',
                  type: 'input',
                  span: 24,
                  maxlength: 100,
                  showWordLimit: true,
                  overHidden: true,
                },
              ],
            },
          },

          {
            label: '备注',
            labelWidth: 120,
            prop: 'remark',
            type: 'textarea',
            maxlength: 300,
            span: 24,
          },
          /*{
            label: '应用到APP',
            prop: 'appFlag',
            hide: true,
            display: false,
            labelWidth: 120,
            type: 'switch',
            dicUrl: '/api/blade-system/dict/dictionary?code=yes_no',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            rules: [
              {
                required: true,
                message: '请输入套餐类型是否应用到APP(套餐)',
              },
            ],
          },*/
          // {
          //   label: '套餐说明',
          //   prop: 'remark',
          //   labelWidth: 120,
          //   type: 'textarea',
          //   minRows: 2,
          //   maxlength: 20,
          //   overHidden: true,
          //   span: 24,
          //   rules: [
          //     {
          //       required: true,
          //       message: '请输入套餐说明',
          //       trigger: 'blur',
          //     },
          //   ],
          //   // addDisplay: false,
          //   // editDisplay: false,
          // },

          /*{
            label: '状态',
            prop: 'status',
            display: false,
            search: false,
            type: 'select',
            width: 80,
            hide: false,
            slot: true,
            editDisabled: true,
            addDisabled: true,
          },*/
        ],
      },
      data: [],
      monthcarFeeTypeList:[]
    };
  },
  watch: {
    /*'form.costPrice'(){
      const column = this.findObject(this.option.column, 'costPrice');
      if(this.form.status == 0){
        column.editDisabled=true;
      }else{
        column.editDisabled=false;
      }
    },
    'form.setmealName'(){
      const column = this.findObject(this.option.column, 'setmealName');
      if(this.form.status == 0){
        column.editDisabled=true;
      }else{
        column.editDisabled=false;
      }
    },
    'form.costSort'(){
      const column = this.findObject(this.option.column, 'costSort');
      if(this.form.status == 0){
        column.editDisabled=true;
      }else{
        column.editDisabled=false;
      }
    },
    'form.remark'(){
      const column = this.findObject(this.option.column, 'remark');
      if(this.form.status == 0){
        column.editDisabled=true;
      }else{
        column.editDisabled=false;
      }
    },*/
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.carmonthchargerule_add, false),
        viewBtn: this.vaildData(this.permission.carmonthchargerule_view, false),
        delBtn: this.vaildData(this.permission.carmonthchargerule_delete, false),
        editBtn: this.vaildData(this.permission.carmonthchargerule_edit, false),
        syncBtn: this.vaildData(this.permission.carmonthchargerule_sync, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.option.height = this.bodyHeight - 380;
    this.initData()
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        document
          .querySelector(
            '#avue-view  div.avue-crud > div.avue-crud__menu > div.avue-crud__right > button:nth-child(3)'
          )
          .addEventListener('click', () => {
            if (this.option.height == this.bodyHeight - 380) {
              this.option.height = this.bodyHeight - 300;
            } else {
              this.option.height = this.bodyHeight - 380;
            }
            this.$refs.crud.getTableHeight();
          });
      }, 1000);
    });
    let self = this;
    this.headerData.forEach((ele, index) => {
      if (ele.type === 'select') {
        getDictionary(ele.dictCode).then((res) => {
          self.headerData[index].list = res.data;
        });
      }
    });
  },
  activated() {
    setTimeout(() => {
      this.$refs.crud.doLayout();
    });
  },
  methods: {
    tableHandleDelete(index, row) {
            this.ruleForm.feeInfos.splice(index, 1); 
    },
    saveRecord(){
      let feeInfosListValide = true;
      let feeInfosListValide2 = true;
      this.ruleForm.feeInfos.forEach((item, index) => {
        console.log(index);
        let str = 'feeInfosRef' + index;
        console.log(str);
        this.$refs[str].validate((valid) => {
          if (valid) {
          } else {
            feeInfosListValide = false;
          }
        });
        let str2 = "feeInfosRef2" + index;
        this.$refs[str2].validate((valid) => {
          if (valid) {
          } else {
            feeInfosListValide2 = false;
          }
        });

      });
      this.$refs['formRef'].validate((valid) => {
          if (valid) {
          } else {
           
          }
        });
    },
    initData(){
      getDictionary("package_type").then(res=>{
        this.packageTypeList = res.data
      })
      getDictionary("billing_method").then(res=>{
        this.billingMethodList = res.data
      })
      getDictionary("car_type_v2").then(res=>{
        this.carTypeList = res.data
      })
      getDictionary("monthcar_fee_type").then(res=>{
        this.monthcarFeeTypeList = res.data
      })
      
    },
    addRecord(){
      this.addFormVisible = true
    },
    handleTableFormData(val) {
      console.log(val);
      this.form.feeInfos = val.tableData;
      this.calculatePrice();
      if (val.delItem && val.delItem.id) {
        removeItem({ id: val.delItem.id }).then((res) => {
          console.log(res);
        });
      }
    },
    handleRuleTableFormData(val) {
      console.log(val);
      this.ruleForm.feeInfos = val.tableData;
      // this.calculatePrice();
     
    },
    calculatePrice() {
      let self = this;
      let price = 0;
      this.form.feeInfos.forEach((item, index) => {
        price = Number(item.itemPrice) + Number(price);
      });
      self.form.costPrice = price;
      console.log('this.form.costPrice===========>', this.form.costPrice);
    },
    handleAdd() {
      this.ruleForm.feeInfos.push({
        feeSort:'',
        itemPrice:'',
        remark:''
      });
    },
    getParkListData() {
      return getParkList();
    },
    getFeeSortListData() {
      return getFeeSortList();
    },
    calculableFee(row) {
      let feeInfos = row.feeInfos;
      let costPrice = 0;
      if (feeInfos.length > 0) {
        feeInfos.forEach((e) => {
          costPrice += parseFloat(e.itemPrice);
        });
      } else {
        costPrice = 0;
      }
      row.costPrice = costPrice.toFixed(2);
      row.spaceName = row.$spaceId;
      // let costSortStr = row.$costSort;
      let spaceIdStr = row.$spaceId;
      if (this.vdui.isNotEmpty(row.costPrice)) {
        // row.remark = spaceIdStr + costSortStr + '  ' + row.costPrice + '元';
        row.remark = spaceIdStr + '  ' + row.costPrice + '元';
      }
    },
    generateRemark() {
      // setTimeout(() => {
      //   let costSortStr = this.form.$costSort;
      //   let spaceIdStr = this.form.$spaceId;
      //   let costPrice = this.form.costPrice;
      //   if (this.vdui.isNotEmpty(costPrice)) {
      //     this.form.remark = spaceIdStr + costSortStr + '  ' + costPrice + '元';
      //   }
      // }, 0);
    },
    monthCarChargeRuleSync() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定同步月卡车收费规则到停车场?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return syncMonthCarChargeRules({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    rowSave(row, loading, done) {
      // this.calculableFee(row);
      console.log('rowSave=====>', row);
      let arr = [];
      let validFlag = false;
      let self = this;
      row.feeInfos.forEach((ele, index) => {
        if (!ele.itemPrice) {
          self.form.feeInfos[index].itemPriceemptyFlag = true;
          validFlag = true;
        }
        if (!ele.feeSort) {
          self.form.feeInfos[index].feeSortemptyFlag = true;
          validFlag = true;
        }
        if (
          ele['itemPriceemptyFlag'] ||
          ele['feeSortemptyFlag'] ||
          ele['itemPricevalideFlag'] ||
          ele['feeSortvalideFlag']
        ) {
          validFlag = true;
        }
        arr.push({
          feeSort: ele.feeSort,
          itemPrice: ele.itemPrice,
          remark: ele.remark,
        });
      });
      row.feeInfos = arr;
      if (validFlag) {
        // this.$message.error('收费标准填写！');
        done();
        return;
      }
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      // this.calculableFee(row);
      console.log('rowSave=====>', row);
      let arr = [];
      let validFlag = false;
      let self = this;
      row.feeInfos.forEach((ele, index) => {
        if (!ele.itemPrice) {
          self.form.feeInfos[index].itemPriceemptyFlag = true;
          validFlag = true;
        }
        if (!ele.feeSort) {
          self.form.feeInfos[index].feeSortemptyFlag = true;
          validFlag = true;
        }
        if (
          ele['itemPriceemptyFlag'] ||
          ele['feeSortemptyFlag'] ||
          ele['itemPricevalideFlag'] ||
          ele['feeSortvalideFlag']
        ) {
          validFlag = true;
        }
        if (ele.id) {
          arr.push({
            feeSort: ele.feeSort,
            itemPrice: ele.itemPrice,
            remark: ele.remark,
            id: ele.id,
            spaceId: ele.spaceId,
            spaceName: ele.spaceName,
          });
        } else {
          arr.push({
            feeSort: ele.feeSort,
            itemPrice: ele.itemPrice,
            remark: ele.remark,
          });
        }
      });
      row.feeInfos = arr;
      if (validFlag) {
        // this.$message.error('收费标准填写！');
        done();
        return;
      }
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    disable(row) {
      if (row.status == 0) {
        this.$message.warning(' 该条月卡车收费规制已停用！');
        return;
      }
      this.$confirm('是否选择停用套餐', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return disable({ id: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      console.log('beforeOpen=====>', type);
      let self = this;
      self.tableViewFlag = false;
      self.validPropList = ['itemPrice', 'feeSort'];
      if (['add'].includes(type)) {
        setTimeout(() => {
          console.log(this.$refs.crud.$refs);
        });
      }
      if (['edit', 'view'].includes(type)) {
        if (['view'].includes(type)) {
          self.tableViewFlag = true;
        }
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
          this.form.carCategory = this.form.carCategory + '';
          this.form.carType = this.form.carType + '';
          this.form.feeInfos.forEach((ele, index) => {
            ele.feeSort = ele.feeSort + '';
          });
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      //每次刷新页面时，开启车场搜索框默然显示第一个节点的名称
      this.firstDisplayFlag = true;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      setTimeout(() => {
        this.$refs.crud.$refs.headerSearch.searchForm.spaceId =
          this.$refs.crud.$refs.headerSearch.searchForm.spaceId || this.parkListData[0].id;
        console.log(this.parkListData);
        this.query.spaceId = this.query.spaceId || this.parkListData[0].key;
        page = page || this.page;
        this.loading = true;
        getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
          ({ data }) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
          }
        );
      });
    },
    getstatus(status) {
      if (status === 1) {
        return '启动';
      } else if (status === 0) {
        return '停用';
      } else {
        return '其他';
      }
    },
  },
};
</script>

<style scoped>
::v-deep .avue-form__menu--center {
  text-align: right;
}
::v-deep .avue-crud__search .el-form-item--small.el-form-item {
  width: 100%;
}
</style>
